<template>
    <div :id="tooltipId">
      <v-card v-if="showTooltip" class="pa-3 mb-6 primary darken-2 overlay-reservoir-center">
          <v-card-title>
            <v-row :align="showTooltip.label_subtitle ? 'start' : 'center'">
              <v-icon v-show="stationIcon" class="pa-n2 mr-2" size="24" :color="stationIcon.color">{{stationIcon.name}}</v-icon>
              <div>
                <h1 v-if="showTooltip.value_title" class="pa-0 ma-0 white--text tooltip-title">
                  <span v-if="showTooltip.label_title">{{showTooltip.label_title}}&nbsp;&nbsp;-&nbsp;&nbsp;</span>{{showTooltip.value_title}}
                </h1>
                <h1 v-else class="pa-0 ma-0 white--text tooltip-title">{{showTooltip.name}}</h1>
                <h2 v-if="showTooltip.value_subtitle" class="mt-0 pa-0 ma-0 tooltip-subtitle">
                  <span v-if="showTooltip.label_subtitle">{{showTooltip.label_subtitle}}:&nbsp;&nbsp;</span>
                  <span >{{showTooltip.value_subtitle}}</span>
                </h2>
              </div>
            </v-row>

          </v-card-title>
          <v-card-text v-if="showTooltip.items.length" class="px-2">
            <div class="mt-4" v-for="(property, index2) in showTooltip.items" :key="index2">
              <v-icon v-if="property.icon_label" class="mr-4" size="24" color="secondary lighten-1">{{ property.icon_label }}</v-icon>
              <span class="white--text mr-1" style="font-weight: normal;font-size: 14px;line-height: 18px;">{{property.label}}:&ensp;</span>
              <strong v-if="property.value && property.label === 'Tipo'" class="white--text" style="font-weight: bold;font-size: 16px;line-height: 20px;">{{stationsTypes[property.value]}}</strong>
              <strong v-else-if ="property.value && property.label ===  'Órgão' && organizations" class="white--text" style="font-weight: bold;font-size: 16px;line-height: 20px;">{{findOrganization(property.value).nome}}</strong>
              <strong v-else class="white--text" style="font-weight: bold;font-size: 16px;line-height: 20px;">Em breve</strong>
            </div>
          </v-card-text>
          <v-card-text v-if="showTooltip.updatedAt">
            <v-row class="align-center justify-start">
              <v-icon class="ml-1 mr-3" color="white" size="24" left >restore</v-icon>
              <span class="white--text" style="font-family: Roboto;font-style: normal;font-weight: normal;font-size: 12px;line-height: 16px;">
                Atualizado em {{ formatDate(showTooltip.updatedAt) }}
              </span>
              <!-- <span v-else class="white--text">Atualizado em ##/##/####</span> -->
            </v-row>
          </v-card-text>
      </v-card>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    name: 'TooltipCardStationsMap',
    props: {
      tooltipParams:{
        type: Array
      },
      tooltipId:{
        type: String,
        default: "tooltip-card"
      }
    },
    data: ()=>({
      stationsTypes: {
        P: "Pluviométrica", M: "Meteorológica", H: "Hidrológica"
      },
      stationsIcons:{
        P: { name: "icon-infohidro-pluviometrica", color: "#00C4F0"}, M: {name: "icon-infohidro-meteorologica", color: "#023373"}, H: {name: "icon-infohidro-hidrologica", color: "#0583F2"}
      },
      stationIcon: undefined,
    }),
    watch:{
      tooltipParams(value){
        if(value && this.showTooltip){
          this.stationIcon = this.findStationIcon(this.showTooltip.items);
        }
      },
    },
    computed:{
        showTooltip(){
            let firstTooltip = undefined;
            if(this.tooltipParams.length){
                firstTooltip = this.tooltipParams[0];
                for (const tooltipKey in this.tooltipParams) {
                if(this.tooltipParams[tooltipKey].zindex > firstTooltip.zindex){
                    firstTooltip = this.tooltipParams[tooltipKey];
                }
                }
            }

            return firstTooltip;
        },
        organizations(){
          return this.$store.getters.organizations;
        }
    },
    methods:{
        formatDate(date){
            return moment(date).format("DD/MM/YYYY HH:mm");
        },
        findOrganization(id){
          return this.organizations.find(organization => organization.codigo == id);
        },
        findStationIcon(items){
          const findItem = items.find(item => item.label === "Tipo");
          const icon=  this.stationsIcons[findItem.value];
          return icon
        }
    }
}
</script>

<style scoped>
    .tooltip {
        width: 300px;
        background-color: black;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 8px;
        opacity: 0.8;
        position: absolute;
        transition: .50s all ease;
        transition-delay: .50s;
        z-index: 1000;
    }
    hr.solid {
        border-top: 3px solid #fff;
    }
    .tooltip-title{
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 20px;
    }
    .tooltip-subtitle{
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
    }
</style>
